import { ShiftType } from '@ms/timesheets/dist/models/shift-type';
import { IOnlineApprovalTimeEntry } from '../models/online-approval-time-entry.model';

export const fakeTimeEntries = [
    {
        isActive: true,
        comment: 'I drove 500 miles today.',
        entryDate: new Date('2020-09-22T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 0,
        id: '83bcf10a-9424-496a-b467-b171411aa4a0',
        stagedTimeEntryId: '83bcf10a-9424-496a-b467-b171411aa4a0',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: 1200,
        timeOut: 1800,
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fa',
    },
    {
        isActive: true,
        comment: null,
        entryDate: new Date('2020-07-17T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 0,
        id: 'f8eb0e5d-8fa3-449d-a373-1a06033eb269',
        stagedTimeEntryId: 'f8eb0e5d-8fa3-449d-a373-1a06033eb269',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0500',
        timeOut: '0600',
        timesheetId: '3e6dd10b-d598-4e1f-be02-9656702910db',
    },
    {
        isActive: true,
        comment:
            'Cupcake ipsum dolor sit amet. Gummi bears jelly beans jelly beans I love I love brownie cake I love caramels.',
        entryDate: new Date('2020-07-14T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 0,
        id: '2532569a-ad27-4f1b-92a4-90846fa52876',
        stagedTimeEntryId: '2532569a-ad27-4f1b-92a4-90846fa52876',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0315',
        timeOut: '0400',
        timesheetId: '3e6dd10b-d598-4e1f-be02-9656702910db',
    },
    {
        isActive: true,
        comment: null,
        entryDate: new Date('2020-08-05T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 0,
        id: 'f9835b2f-e607-4635-8487-cac753a0d120',
        stagedTimeEntryId: 'f9835b2f-e607-4635-8487-cac753a0d120',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0200',
        timeOut: '0100',
        timesheetId: 'ada8a376-755a-4781-86a2-de5055178893',
    },
    {
        isActive: true,
        comment: 'Pie donut sesame snaps cookie I love cookie.',
        entryDate: new Date('2020-09-23T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 0,
        id: 'c3797600-c827-4037-a9ca-782c5bb5f75f',
        stagedTimeEntryId: 'c3797600-c827-4037-a9ca-782c5bb5f75f',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: 1200,
        timeOut: 1800,
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fa',
    },
    {
        isActive: true,
        comment: null,
        entryDate: new Date('2020-09-22T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 1,
        id: 'ff7f7342-e8ee-475f-9d1c-51efa85b48d5',
        stagedTimeEntryId: 'ff7f7342-e8ee-475f-9d1c-51efa85b48d5',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0100',
        timeOut: '0800',
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fa',
    },
    {
        isActive: true,
        comment: 'Apple pie pastry pudding cupcake jelly-o gummi bears chocolate cake sweet roll.',
        entryDate: new Date('2020-09-22T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 1,
        id: 'ff7f7342-e8ee-475f-9d1c-51efa85b48d5',
        stagedTimeEntryId: 'ff7f7342-e8ee-475f-9d1c-51efa85b48d5',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0100',
        timeOut: '0800',
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fb',
    },
    {
        isActive: true,
        comment: null,
        entryDate: new Date('2020-09-22T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 1,
        id: 'ff7f7342-e8ee-475f-9d1c-51efa85b48d6',
        stagedTimeEntryId: 'ff7f7342-e8ee-475f-9d1c-51efa85b48d6',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0100',
        timeOut: '0800',
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fc',
    },
    {
        isActive: true,
        comment: 'Chocolate icing jelly chocolate bar I love chupa chups pudding chocolate cake.',
        entryDate: new Date('2020-09-22T00:00:00'),
        hasLunch: false,
        hoursAdjustment: 1,
        id: '19d66d38-d754-4fc7-bebf-d051cbd56ff3',
        stagedTimeEntryId: '19d66d38-d754-4fc7-bebf-d051cbd56ff3',
        isFacilityTimeOff: false,
        isPersonalTimeOff: false,
        lunchIn: null,
        lunchOut: null,
        shiftType: ShiftType.Regular,
        timeIn: '0100',
        timeOut: '0800',
        timesheetId: '3e6dd10b-d598-4e1f-be02-9656702910dc',
    },
] as IOnlineApprovalTimeEntry[];
